export default __webpack_public_path__ + "static/5-6eee112bf5477809194cdd4e34249264.jpg";